module.exports = __webpack_public_path__ + "static/media/IMG_044.aff4078f.PNG";